<!-- Acerca de la App -->
<swal
  #aboutSwal
  [width]="swalWidth"
  [showClass]="fadeInClass"
  [showCancelButton]="false"
  [allowEscapeKey]="false"
  [allowOutsideClick]="false"
  [heightAuto]="false"
  [showConfirmButton]="false"
  [confirmButtonColor]="swalConfirmButtonAndIconColor"
  [iconColor]="swalConfirmButtonAndIconColor"
>
  <ng-container *swalPortal="swalTargets.title">
    <div class="img-container">
      <img
        class="animate__animated animate__faster animate__bounceIn"
        src="../../../assets/imagenes/icons/512x512.png"
        height="86"
        alt="logo {{ 'platform_smartCity' | translate }}"
      />
    </div>
    <h2 class="titulo-alerta">
      {{ "platform_smartCity" | translate }} <b>v{{ version }}</b>
    </h2>
    <h3 class="centered-text">
      <small (click)="updateHistory()" style="font-size: small"
        ><a>{{ "historial-versiones" | translate }}</a></small
      >
    </h3>
    <br />
    <div class="buttons">
      
      <div class="button-container">
        <button
          class="icon-button"
          color="primary"
          (click)="getCurrentVersionChanges()"
          mat-flat-button
        >
          @if (!isMobile) {
            <mat-icon fontSet="material-symbols-outlined">list_alt</mat-icon>
          }
          <span>{{ "que-hay-nuevo" | translate }}</span>
        </button>
        <button
          mat-stroked-button
          color="primary"
          (click)="lookForUpdates()"
          style="font-size: small"
        >
          @if (!isMobile) {
            <mat-icon fontSet="material-symbols-outlined">system_update_alt</mat-icon>
          }
          {{ "comprobar-actualizaciones" | translate }}
        </button>
      </div>

      <button
        class="icon-button back-button right"
        color="primary"
        (click)="aboutSwal.close()"
        mat-button
      >
        <span class="message-close-dialog-about">{{ "cerrar" | translate }}</span>
      </button>
    </div>
  </ng-container>
  <ng-container *swalPortal="swalTargets.footer">
    <h4 class="centered-text title">{{ "certificaciones" | translate }}:</h4>
    <a [href]="fileUrl" [download]="fileUrl">{{ "ENS" | translate }}</a>
  </ng-container>
</swal>

<!-- Cambios de la última versión -->
<swal
  #changesSwal
  [width]="swalWidth"
  [showClass]="fadeInClass"
  [showCancelButton]="false"
  [showConfirmButton]="false"
  [allowEscapeKey]="false"
  [allowOutsideClick]="false"
  [heightAuto]="false"
  [confirmButtonColor]="swalConfirmButtonAndIconColor"
  [iconColor]="swalConfirmButtonAndIconColor"
  (didClose)="clearUpdateMessage()"
>
  <ng-container *swalPortal="swalTargets.title">
    <div class="img-container">
      <img
        class="animate__animated animate__faster animate__bounceIn"
        src="../../../assets/imagenes/icons/512x512.png"
        height="86"
        alt="logo {{ 'platform_smartCity' | translate }}"
      />
    </div>
    <h2 class="titulo-alerta">
      {{ "platform_smartCity" | translate }}
      @if (!oldVersionInfo) {
        <b>v{{ version }}</b>
      }
      @if (oldVersionInfo) {
        <b>v{{ oldVersionInfo.tag_name }}</b>
      }
    </h2>
  </ng-container>

  <ng-container *swalPortal="swalTargets.content">
    @if ((currentVersion && !versionInfo) || (!currentVersion && !oldVersionInfo)) {
      <div class="loader">
        <mat-spinner [diameter]="30" mode="indeterminate"></mat-spinner>
      </div>
    }

    @if (!currentVersion) {
      <markdown
        class="changelog-container"
        [data]="oldVersionInfo !== null && oldVersionInfo.body"
      ></markdown>
    }
    @if (currentVersion) {
      <markdown
        class="changelog-container"
        [data]="versionInfo !== null && versionInfo.body"
      ></markdown>
    }

    @if (!versionInfo?.body) {
      <div class="no-results">
        <p>{{ "no-hay-novedades-disponibles" | translate }}</p>
      </div>
    }
    <div class="buttons">
      <button
        class="icon-button back-button left"
        color="primary"
        (click)="changesSwal.close(); (currentVersion ? aboutSwal.fire(): versionsListSwal.fire())"
        mat-button
      >
        <span>{{ "volver-a-inicio" | translate }}</span>
      </button>

      <button
        class="icon-button back-button right"
        color="primary"
        (click)="changesSwal.close()"
        mat-button
      >
        <span>{{ "cerrar" | translate }}</span>
      </button>
    </div>
  </ng-container>
</swal>

<!-- Listado de Versiones -->
<swal
  #versionsListSwal
  [width]="isMobile ? '95vw' : '50vw'"
  [showClass]="fadeInClass"
  [showCancelButton]="false"
  [showConfirmButton]="false"
  [allowEscapeKey]="false"
  [allowOutsideClick]="false"
  [heightAuto]="false"
  [confirmButtonColor]="swalConfirmButtonAndIconColor"
  [iconColor]="swalConfirmButtonAndIconColor"
>
  <ng-container *swalPortal="swalTargets.title">
    <h3 class="titulo-alerta">
      <b>{{ "platform_smartCity" | translate }}</b> <br />
      <small>{{ "historial-versiones" | translate }}</small>
    </h3>
  </ng-container>

  <ng-container *swalPortal="swalTargets.content">
    <mat-list class="versions-list">
      <div mat-subheader>{{ "versiones" }}</div>
      
      @if (versionsList.length <= 0) {
        <div class="no-results">
          <p>{{ "no-hay-versiones-disponibles" | translate }}</p>
        </div>
      }
      @for (
        versionLog of versionsList
          | slice
            : releasePaginator.pageIndex * releasePaginator.pageSize
            : (releasePaginator.pageIndex + 1) * releasePaginator.pageSize;
        track versionLog.tag_name
      ) {
        <mat-list-item>
          <div matListItemTitle>
            <b>v{{ versionLog.tag_name }}</b>
            @if (versionLog.tag_name === this.version) {
              <span class="current-version-txt">
                &nbsp; {{ "version-actual" | translate }}
              </span>
            }
          </div>
          <div matListItemLine>
            <small>{{ versionLog.published_at | cityTimezoneDate }}</small>
          </div>
          <span matListItemMeta>
            <button
              (click)="getVersionDetails(versionLog.tag_name)"
              color="primary"
              mat-icon-button
            >
              <mat-icon>visibility</mat-icon>
            </button>
          </span>
        </mat-list-item>
      }
    </mat-list>

    <div class="d-flex paginator-container">
      <mat-paginator
        #releasePaginator
        AppStylePaginator
        showFirstLastButtons
        [showTotalPages]="3"
        [length]="versionsList.length"
        [pageSize]="5"
      >
      </mat-paginator>
    </div>

    <div class="buttons">
      <button
        class="icon-button back-button left"
        color="primary"
        (click)="versionsListSwal.close(); aboutSwal.fire()"
        mat-button
      >
        <span>{{ "volver-a-inicio" | translate }}</span>
      </button>

      <button
        class="icon-button back-button right"
        color="primary"
        (click)="versionsListSwal.close()"
        mat-button
      >
        <span>{{ "cerrar" | translate }}</span>
      </button>
    </div>
  </ng-container>
</swal>

<!-- Términos ENS -->
<swal
  #terminos
  [width]="swalWidth"
  [showClass]="fadeInClass"
  [showCancelButton]="false"
  [allowEscapeKey]="false"
  [allowOutsideClick]="false"
  [confirmButtonColor]="swalConfirmButtonAndIconColor"
  icon="warning"
  [iconColor]="swalConfirmButtonAndIconColor"
  [customClass]="{
    popup: 'swal-customclass',
    container: 'container-swal-customclass'
  }"
  (confirm)="confirmarTerminos()"
>
  <ng-container *swalPortal="swalTargets.title">
    <h2 class="titulo-alerta">
      {{ "Advertencia" | translate }}
    </h2>
  </ng-container>

  <ng-container *swalPortal="swalTargets.content">
    <div>
      <p class="texto-alerta">
        {{ "advertencia_terminos" | translate }}
      </p>
    </div>

    <div class="checkbox-container">
      <mat-checkbox
        color="primary"
        [checked]="dontShowAgain"
        (change)="onCheckboxChange($event)"
      >
        {{ "no_mostrar_terminos" | translate }}
      </mat-checkbox>
    </div>
  </ng-container>

  <ng-container *swalPortal="swalTargets.confirmButton">
    <span class="span-button">
      {{ "aceptar" | translate }}
    </span>
  </ng-container>

  <ng-container *swalPortal="swalTargets.footer">
    <div class="terminos-footer">
      <b>
        {{ "ultimo_inicio_sesion" | translate }} :
        {{
          ultimo_inicio_sesion
            ? (ultimo_inicio_sesion | cityTimezoneDate : "MMM dd yyyy, h:mm:ss a")
            : "---"
        }}
      </b>
    </div>
  </ng-container>
</swal>
